import MDButton from 'components/MDButton'
import AddBoxIcon from '@mui/icons-material/AddBox'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDInput from 'components/MDInput'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { useParams } from 'react-router-dom'
import { Checkbox, FormControlLabel } from '@mui/material'
const CreateModal = ({ editData, handleRefresh }) => {
  const Service = useAppServices()
  const { location_id, app_id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const payload = {
        _id: editData?._id,
        app_name: e.target.app_name.value,
        app_id: e.target.app_id.value,
        agency_type: e.target.agency_type.checked,
        sub_account_type: e.target.sub_account_type.checked,
        main_app_id: app_id,
        location_id: location_id,
      }
      const { response } = await Service.snapshot_onboarding.update({ payload })
      if (response) {
        setOpenAddProduct(false)
        setProcessing(false)
        handleRefresh()
      } else {
        setProcessing(false)
      }
    }
    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox>
          <MDTypography component="h1" mb={3} variant="h5">
            App
          </MDTypography>

          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={{ width: 335 }}>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  App Name
                </MDTypography>
                <MDInput
                  defaultValue={editData?.app_name}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="App Name"
                  name="app_name"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  App ID
                </MDTypography>
                <MDInput
                  defaultValue={editData?.app_id}
                  id="bootstrap-input"
                  fullWidth
                  placeholder="App ID"
                  name="app_id"
                />
              </MDBox>
            </Grid>

            <Grid item md={12} mt={3}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Distribution Type
                </MDTypography>
              </MDBox>
            </Grid>

            <Grid container item md={10}>
              <Grid item xs={5}>
                <MDBox mb={0.5}>
                  <FormControlLabel
                    control={<Checkbox name="agency_type" defaultChecked={editData?.agency_type} />}
                    label="Agency"
                  />
                </MDBox>
              </Grid>

              <Grid item xs={6}>
                <MDBox mb={0.5}>
                  {' '}
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="sub_account_type"
                        defaultChecked={editData?.sub_account_type}
                      />
                    }
                    label="Sub-Account"
                  />
                </MDBox>
              </Grid>
            </Grid>

            <MDBox>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                disabled={processing}
                loading={processing}
                sx={{ mt: 4, mb: 1 }}
                fullWidth
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = (subscription) => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton
        sx={{ marginLeft: '4px' }}
        variant="contained"
        color="info"
        size="small"
        onClick={() => setOpenAddProduct(true)}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
